import React from 'react';
const PlayIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} fill="white" {...props}>
    <path fill="#F5F6F8" d="M20 16h25v26H20z" />
    <path
      fill="#323232"
      d="M30 5C16.2 5 5 16.2 5 30s11.2 25 25 25 25-11.2 25-25S43.8 5 30 5Zm-5 33.75v-17.5c0-1.025 1.175-1.625 2-1L38.675 29c.675.5.675 1.5 0 2L27 39.75c-.825.625-2 .025-2-1Z"
    />
  </svg>
);
export default PlayIcon;
